import React from "react";
import PropTypes from "prop-types";
import ContainerReponse from "../../Layout/ContainerReponse/ContainerReponse";
import ChatFormInput from "../../shared/ChatFormInput/ChatFormInput";
import SendButton from "../../shared/SendButton/SendButton";
import AddFile from "../../../../containers/Chat/shared/AddFile";

const Form = ({
														setMessageValue,
														messageValue,
														cas,
														postMessage,
														documents,
														setShowModalRerender,
														setShowModalNoRerender,
														showModalNoRerender,
														showModal
														}) => {
const handleSubmit = (e) => {
if (messageValue === "") {
e.preventDefault();
} else {
e.preventDefault();
// On post le message
postMessage();
// On reset l'input
setMessageValue("");
}
};
const handleChange = (e) => {
setMessageValue(e.target.value, cas.id);
};

return (
<ContainerReponse>
<ChatFormInput
onSubmit={handleSubmit}
type="text"
label="Envoyer votre message"
value={messageValue.message}
onChange={handleChange}
valueToActive={messageValue}
required={true}
>
<AddFile
documents={documents}
setShowModalRerender={setShowModalRerender}
setShowModalNoRerender={setShowModalNoRerender}
showModalNoRerender={showModalNoRerender}
showModal={showModal}
/>
<SendButton disabled={!messageValue ? true : false}/>
</ChatFormInput>
</ContainerReponse>
);
};

Form.propTypes = {
messageValue: PropTypes.object,
setMessageValue: PropTypes.func,
addMessage: PropTypes.func,
postMessage: PropTypes.func,
cas: PropTypes.object,
documents: PropTypes.array,
setShowModalNoRerender: PropTypes.func,
setShowModalRerender: PropTypes.func,
showModal: PropTypes.bool,
showModalNoRerender: PropTypes.bool
};

export default Form;
